<!-- 标题,图标加标题文字 -->
<template>
  <div class="title-box">
    <picture>
      <source media="(max-width: 768px)" srcset="@/assets/img/md/desc/title.png">
      <source media="(min-width: 768px)" srcset="@/assets/img/lg/desc/title.png">
      <img src="@/assets/img/lg/desc/title.png" class="pr-2" />
    </picture>
    <h1 class="font-weight-bold pb-3 title-descName display-inline-block">{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: 'MainTitle',
  components: {},
  props: {
    title: {
      type: String,
      default:''
    }
  },
  data() {
    return {
    
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style scoped>
.title-box img{
  vertical-align: middle;
}
</style>